import React from 'react'
import { csx, cx } from '@vtex/admin-ui'
import type { FlexProps } from '@vtex/admin-ui'

export type IndicatorComparisonContainerProps = FlexProps

export const IndicatorComparisonContainer = ({
  className = '',
  ...props
}: IndicatorComparisonContainerProps) => (
  <div
    className={cx(
      csx({
        display: 'flex',
        justifyContent: 'space-between',
      }),
      className
    )}
    justify="space-between"
    {...props}
  />
)
